export default "__VITE_ASSET__C04NvXYa__"